import React, { lazy, Suspense } from 'react';
import Loading from './components/Loading';
import { CONVERSATION_URI, LOGIN_URI } from './constants/routes';
import { Route, createRoutesFromElements, createBrowserRouter, RouterProvider } from 'react-router-dom';

const Login = lazy(() => import('./containers/login/Login'));
const Conversation = lazy(() => import('./containers/conversation/Conversation'));

const createManualRoutes = () => {
  return createRoutesFromElements(
    <Route>
      <Route path={LOGIN_URI} element={<Login />} />
      <Route path={CONVERSATION_URI} element={<Conversation />} />
    </Route>,
  );
};

const createRouter = () => {
  const manualRoutes = createManualRoutes();
  return createBrowserRouter(manualRoutes, {
    future: {
      v7_relativeSplatPath: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_fetcherPersist: true,
      v7_skipActionErrorRevalidation: true,
    },
  });
};

function Router() {
  const router = createRouter();
  return (
    <Suspense fallback={<Loading open />}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </Suspense>
  );
}

export default Router;
